module.exports = __webpack_public_path__ + "static/media/elegir_xEN.b221ad37.svg";